import { useEffect, useState } from 'react';
import { BREAKPOINTS } from '@constants/responsive';

export interface BreakpointState {
  width: number;
  isMobile: boolean;
  isDesktop: boolean;
}

function read(): BreakpointState {
  const width = typeof window !== 'undefined' ? window.innerWidth : BREAKPOINTS.desktop;
  return {
    width,
    isMobile: width < BREAKPOINTS.widgetMobile,
    isDesktop: width >= BREAKPOINTS.widgetMobile,
  };
}

/**
 * Tracks the viewport width and exposes simple mobile/desktop flags.
 * Split point: < 600 => mobile, >= 600 => desktop (see responsive.ts).
 */
export function useBreakpoint(): BreakpointState {
  const [state, setState] = useState<BreakpointState>(read);

  useEffect(() => {
    function handleResize() {
      setState(read());
    }
    window.addEventListener('resize', handleResize);
    // Sync once on mount in case SSR/default differed from actual width.
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return state;
}

export default useBreakpoint;
